import JobDetail3Container from "../../../components/job/detail/JobDetail3";

const JobDetail3 = () => {
  return <JobDetail3Container />;
};

export default JobDetail3;
